import { api, toList } from '../apiClient';

// Super-admin engagement campaigns (in-app + push + email nudges). All endpoints require SUPER_ADMIN.
export const campaignService = {
  // size=100 so the single scrollable list shows every campaign (super-admin tool; no page controls).
  list:    (params = {}) => api.get('/admin/campaigns', { params: { size: 100, ...params } }).then(toList),
  get:     (id)          => api.get(`/admin/campaigns/${id}`),
  create:  (data)        => api.post('/admin/campaigns', data),
  update:  (id, data)    => api.put(`/admin/campaigns/${id}`, data),
  remove:  (id)          => api.delete(`/admin/campaigns/${id}`),
  duplicate: (id)        => api.post(`/admin/campaigns/${id}/duplicate`),
  preview: (id)          => api.post(`/admin/campaigns/${id}/preview`),  // -> { reach }
  send:    (id)          => api.post(`/admin/campaigns/${id}/send`),
  // Attribute an in-app-notification click to a campaign (signed-in user). Fire-and-forget.
  clicked: (id, channel = "IN_APP") => api.post(`/campaigns/${id}/clicked?channel=${channel}`),
};
